import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getStatesOfCountry } from "country-state-city/lib/state";
import './ratecalculator.css';

const RateCalculator = () => {
  const location = useLocation();
  const states = getStatesOfCountry("IN");

  const [selectedState, setSelectedState] = useState("");
  const [activeMetal, setActiveMetal] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [purity, setPurity] = useState("24");
  const [price, setPrice] = useState(null);

  const metals = [
    { id: "XAU", metal: "Gold" },
    { id: "XAG", metal: "Silver" },
  ];

  useEffect(() => {
    // const params = new URLSearchParams(window.location.search);

    // const stateParam = params.get("state");

    const path = window.location.pathname.toLowerCase();

    const metalFromPath = path.includes("gold")
      ? "Gold"
      : path.includes("silver")
        ? "Silver"
        : "";

    if (metalFromPath) {
      setActiveMetal(metalFromPath);
    }
  }, [location]);

  useEffect(() => {
    const savedMetal = localStorage.getItem("selectedMetal");
    if (savedMetal) {
      setActiveMetal(savedMetal);
    }
  }, []);

  useEffect(() => {
    if (activeMetal) {
      localStorage.setItem("selectedMetal", activeMetal);
    }
  }, [activeMetal]);

  const calculte = (e) => {
    e.preventDefault();

  }

  return (
    <div className="calculator">
      <h3>{activeMetal || "Metal"} Rate Calculator</h3>

      <form onSubmit={calculte}>
        <div className="input-box">
          <select
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
            label="Select State"
            required
          >
            <option value="" disabled>Select a State</option>
            {states?.map((state) => (
              <option key={state.isoCode} value={state.name}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        <div className="input-box">
          <ul>
            {metals.map(({ metal, id }) => (
              <li
                key={id}
                className={activeMetal === metal ? "active" : ""}
                onClick={() => setActiveMetal(metal)}
              >
                {metal}
              </li>
            ))}
          </ul>
        </div>

        <div className="input-box">
          <span>Quantity (gram)</span>
          <input
            type="number"
            name="quantity"
            value={quantity}
            onChange={(e) => {
              const value = Number(e.target.value);
              setQuantity(value);
            }}
            label="Quantity"
            required
          />
        </div>

        {
          activeMetal === "Gold" ? (
            <div className="radio-box">
              <span>Purity</span>

              <input
                type="radio"
                name="purity"
                id="carat24"
                value="24"
                checked={purity === "24"}
                onChange={(e) => setPurity(e.target.value)}
              />
              <label htmlFor="carat24">24 Carat</label>

              <input
                type="radio"
                name="purity"
                id="carat22"
                value="22"
                checked={purity === "22"}
                onChange={(e) => setPurity(e.target.value)}
              />
              <label htmlFor="carat22">22 Carat</label>
            </div>
          ) : ""
        }

        <div className="submit-button">
          <button>Calculate</button>
        </div>
      </form>

      <div className="result">
        <p>
          {activeMetal} Rate in {selectedState || "State"} for <br />
          {quantity >= 1000
            ? `${quantity / 1000} kg`
            : `${quantity} gram`}{" "}
          {activeMetal === "Gold" ? `${purity} Carat` : ""} is: ₹66666</p>
      </div>
    </div>
  );
};

export default RateCalculator;
